/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { Card, Select } from "antd";
import { ExportToExcel } from "../../../../utils";

export const ChartCategory = ({ data }) => {
  const [chartData, setChartData] = useState([]);
  const [exportSalesData, setExportSalesData] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState('all');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const uniqueChannels = [...new Set(data.map(order => order.channel))];
  useEffect(() => {
    const processedData = processData(data);
    const generatedExportData = generateExportData(data);
    setChartData(processedData);
    setExportSalesData(generatedExportData);
  }, [data, selectedChannel]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const processData = (data) => {
    const filteredData = selectedChannel === 'all'
      ? data
      : data.filter(order => order.channel === selectedChannel);
    const deliveredOrders = filteredData?.filter((order) => order.status === "Entregado"

    );
    let salesByCategory = {};
    let totalSalesByCategory = {};

    filteredData?.forEach((order) => {
      order.products?.forEach((item) => {
        if (!totalSalesByCategory[item.category]) {
          totalSalesByCategory[item.category] = {
            totalSales: 0,
            totalItems: 0,
            totalOrders: 0,
          };
        }
        totalSalesByCategory[item.category].totalSales +=
          item.total * item.quantity;
        totalSalesByCategory[item.category].totalItems += item.quantity;
        totalSalesByCategory[item.category].totalOrders++;
      });
    });

    deliveredOrders?.forEach((order) => {
      order.products?.forEach((item) => {
        if (!salesByCategory[item.category]) {
          salesByCategory[item.category] = {
            totalSales: 0,
            totalItems: 0,
            totalOrders: 0,
          };
        }
        salesByCategory[item.category].totalSales += item.total * item.quantity;
        salesByCategory[item.category].totalItems += item.quantity;
        salesByCategory[item.category].totalOrders++;
      });
    });

    const chartData = Object.keys(totalSalesByCategory)?.map((category) => {
      const categoryData = totalSalesByCategory[category];
      const deliveredData = salesByCategory[category] || {
        totalSales: 0,
        totalItems: 0,
        totalOrders: 0,
      };
      return {
        category,
        totalSales: categoryData.totalSales,
        totalItems: categoryData.totalItems,
        totalOrders: categoryData.totalOrders,
        deliveredSales: deliveredData.totalSales,
        averageTicket: categoryData.totalItems / categoryData.totalOrders,
        deliveredAverageTicket:
          deliveredData.totalItems / deliveredData.totalOrders || 0,
      };
    });

    const sortedChartData = chartData?.sort((a, b) => b.totalSales - a.totalSales);
    return sortedChartData;
  };

  const generateExportData = (data) => {
    const filteredData = selectedChannel === 'all'
    ? data
    : data.filter(order => order.channel === selectedChannel);

    let totalSalesExport = {};
    const exportDataArray = [];

    filteredData?.forEach((order) => {
      if(!totalSalesExport[order.salesclosingchannel]){
        totalSalesExport[order.salesclosingchannel] = {};
      }
      order.products?.forEach((item) => {

        if (!totalSalesExport[order.salesclosingchannel][item.category]) {
          totalSalesExport[order.salesclosingchannel][item.category] = {};
        }

        if(!totalSalesExport[order.salesclosingchannel][item.category][item.brand]){
          totalSalesExport[order.salesclosingchannel][item.category][item.brand] = {
            totalSales: 0,
            totalItems: 0,
            totalOrders: 0,
          };    
        }
        
        totalSalesExport[order.salesclosingchannel][item.category][item.brand].totalSales +=
          item.total * item.quantity;
        totalSalesExport[order.salesclosingchannel][item.category][item.brand].totalItems += item.quantity;
        totalSalesExport[order.salesclosingchannel][item.category][item.brand].totalOrders++;
      });
    });
    // eslint-disable-next-line
    Object.keys(totalSalesExport)?.map((closingChannel) => {
      // eslint-disable-next-line
      Object.keys(totalSalesExport[closingChannel])?.map((category)=>{
        // eslint-disable-next-line
        Object.keys(totalSalesExport[closingChannel][category])?.map((brand) => {
          const record = {
            closingChannel,
            category,
            brand,
            ...totalSalesExport[closingChannel][category][brand],
            averageTicket : totalSalesExport[closingChannel][category][brand].totalItems / totalSalesExport[closingChannel][category][brand].totalOrders,
          };
          exportDataArray.push(record);
        });
      });
    });

    return exportDataArray;

  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          <b className="intro">{label}</b>
          <p className="intro">{`Ventas totales: S/ ${payload[0].payload.totalSales.toFixed(
            2
          )}`}</p>
          <p className="desc">{`Cantidad de productos: ${payload[0].payload.totalItems}`}</p>
          <p className="desc">{`Cantidad de ordenes: ${payload[0].payload.totalOrders}`}</p>
          <p className="desc">{`Ticket promedio: ${payload[0].payload.averageTicket.toFixed(
            2
          )}`}</p>
        </div>
      );
    }

    return null;
  };

  const renderCustomizedLabel = (props) => {
    const { x, y, value } = props;

    return (
      <text
        x={x + 37}
        y={y - 5}
        fill="#000"
        textAnchor="middle"
        dominantBaseline="start"
        style={{ fontSize: "14px" }}
      >
        {`S/ ${value.toFixed(2)}`}
      </text>
    );
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const exportData = exportSalesData?.map((item) => ({
    "Canal cierre": item.closingChannel,
    Categoria: item.category,
    Marca: item.brand,
    "Ventas totales": `$${item.totalSales.toFixed(2)}`,
    "Cantidad de productos": item.totalItems,
    "Cantidad de ordenes": item.totalOrders,
    "Ticket promedio": item.averageTicket.toFixed(2)
  }));

  const exportColumns = [
    { title: 'Canal cierre', dataIndex: 'Canal cierre', key: 'Canal cierre' },
    { title: 'Categoría', dataIndex: 'Categoria', key: 'Categoria' },
    { title: 'Marca', dataIndex: 'Marca', key: 'Marca' },
    { title: 'Ventas totales', dataIndex: 'Ventas totales', key: 'Ventas totales' },
    { title: 'Cantidad de productos', dataIndex: 'Cantidad de productos', key: 'Cantidad de productos' },
    { title: 'Cantidad de ordenes', dataIndex: 'Cantidad de ordenes', key: 'Cantidad de ordenes' },
    { title: 'Ticket promedio', dataIndex: 'Ticket promedio', key: 'Ticket promedio' }
  ];

  return (
    <Card title="Categorias" extra={
      <div className="flex">
        <Select
          defaultValue="all"
          style={{ width: 200 }}
          onChange={value => setSelectedChannel(value)}
        >
          <Select.Option value="all">Todos los Canales</Select.Option>
          {uniqueChannels.map(channel => (
            <Select.Option key={channel} value={channel}>
              {channel}
            </Select.Option>
          ))}
        </Select>
      </div>
    }>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData} layout="horizontal" margin={{ top: 30 }}>
          <CartesianGrid
            strokeDasharray="3 3"
            strokeOpacity={0.5}
            tick={{ fontSize: "15px" }}
          />
          <XAxis
            dataKey="category"
            type="category"
            tick={{ fontSize: "14px" }}
          />
          <YAxis type="number" />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="totalSales" fill="#275F6F">
            {windowWidth > 768 && (
              <LabelList dataKey="totalSales" content={renderCustomizedLabel} />
            )}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 10,
          marginRight: 20,
        }}
      >
        <ExportToExcel
          data={exportData}
          columns={exportColumns}
          fileName="resumenCategorias"
        />
      </div>
    </Card>
  );
};
